module.exports = __webpack_public_path__ + "static/assets/dcb2ac8ab0c3963003fd5dfac5015e18.svg";